import { createContext, useContext, useEffect, useState } from "react";
// import { auth } from './firebase';
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import apiClient, { logoutAdmin } from "../../helpers/apiClient";
import { useToast } from "../ToastContext";

const AuthContext = createContext();

export default function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation("login");
    const toast = useToast();

    const signup = () => Promise.reject(new Error("Firebase signup disabled"));

    const signin = async (email, password) => {
        setLoading(true);
        try {
            const response = await apiClient.post("/api/auth/login", {
                email,
                password,
            });

            if (response.data.success) {
                const userResponse = await apiClient.get("/api/account/me");

                if (userResponse.data.success) {
                    const user = userResponse.data.data || {};
                    setCurrentUser(user);
                }
            }

            return response.data;
        } catch (error) {
            throw error.response?.data?.message || "Login failed";
        } finally {
            setLoading(false);
        }
    };

    const signout = async () => {
        try {
            await logoutAdmin();
        } catch {
            // still clear local state if API fails
        }
        setCurrentUser(null);
    };

    const passwordReset = () => Promise.reject(new Error("Firebase password reset disabled"));

    useEffect(() => {
        const checkSession = async () => {
            try {
                const response = await apiClient.get("/api/account/me");
                const user = response.data.data || {};

                setCurrentUser(user);
            } catch (_error) {
                toast.error({
                    message: t("sessionExpired"),
                });
            } finally {
                setLoading(false);
            }
        };

        checkSession();
    }, [t, toast]);

    const value = {
        currentUser,
        signup,
        signin,
        signout,
        passwordReset,
    };

    return <AuthContext.Provider value={value}>{!loading && children}</AuthContext.Provider>;
}

AuthProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export function useAuth() {
    return useContext(AuthContext);
}
